import { render, staticRenderFns } from "./MainPage.vue?vue&type=template&id=50c11e46&scoped=true&"
import script from "./MainPage.vue?vue&type=script&lang=js&"
export * from "./MainPage.vue?vue&type=script&lang=js&"
import style0 from "./MainPage.vue?vue&type=style&index=0&id=50c11e46&scoped=true&lang=css&"
import style1 from "./MainPage.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c11e46",
  null
  
)

component.options.__file = "MainPage.vue"
export default component.exports